import {
  SnippetElement,
  defineElement,
  onClick,
  param,
  query,
  wait
} from "./chunk-DNDL4K7L.js";
import {
  __async,
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/snippets/util-drawer/util-drawer.ts
var UtilDrawer = class extends SnippetElement {
  constructor() {
    super();
    this.isOpen = false;
    this.init();
  }
  init() {
    return __async(this, null, function* () {
      if (this.key != null && UtilDrawer.states[this.key]) {
        this.drawer.classList.add("!duration-0");
        this.backdrop.classList.add("!duration-0");
        yield this.open();
        yield wait(10);
        this.drawer.classList.remove("!duration-0");
        this.backdrop.classList.remove("!duration-0");
      }
    });
  }
  saveState() {
    if (this.key != null) {
      UtilDrawer.states[this.key] = this.isOpen;
    }
  }
  open(side) {
    return __async(this, null, function* () {
      var _a, _b, _c, _d;
      this.isOpen = true;
      this.drawer.classList.add("flex");
      this.drawer.classList.remove("hidden");
      (_a = this.backdrop) == null ? void 0 : _a.classList.remove("hidden");
      yield wait(3);
      (_b = this.backdrop) == null ? void 0 : _b.classList.add("opacity-100");
      (_c = this.backdrop) == null ? void 0 : _c.classList.remove("opacity-0");
      switch ((_d = this.side) != null ? _d : side) {
        case "right":
          this.drawer.classList.add("translate-x-0");
          this.drawer.classList.remove("translate-x-full");
          break;
        case "top":
          this.drawer.classList.add("translate-y-0");
          this.drawer.classList.remove("-translate-y-full");
          break;
        case "bottom":
          this.drawer.classList.add("translate-y-0");
          this.drawer.classList.remove("translate-y-full");
          break;
        default:
          this.drawer.classList.add("translate-x-0");
          this.drawer.classList.remove("-translate-x-full");
      }
    });
  }
  close(side) {
    return __async(this, null, function* () {
      var _a, _b, _c, _d;
      this.isOpen = false;
      (_a = this.backdrop) == null ? void 0 : _a.classList.add("opacity-0");
      (_b = this.backdrop) == null ? void 0 : _b.classList.remove("opacity-100");
      switch ((_c = this.side) != null ? _c : side) {
        case "right":
          this.drawer.classList.remove("translate-x-0");
          this.drawer.classList.add("translate-x-full");
          break;
        case "top":
          this.drawer.classList.remove("translate-y-0");
          this.drawer.classList.add("-translate-y-full");
          break;
        case "bottom":
          this.drawer.classList.remove("translate-y-0");
          this.drawer.classList.add("translate-y-full");
          break;
        default:
          this.drawer.classList.remove("translate-x-0");
          this.drawer.classList.add("-translate-x-full");
      }
      yield wait(300);
      if (!this.isOpen) {
        this.drawer.classList.add("hidden");
        this.drawer.classList.remove("flex");
        (_d = this.backdrop) == null ? void 0 : _d.classList.add("hidden");
      }
      this.saveState();
    });
  }
  toggle() {
    return __async(this, null, function* () {
      if (this.isOpen) {
        yield this.close();
      } else {
        yield this.open();
      }
    });
  }
  disconnectedCallback() {
    this.remove();
  }
};
UtilDrawer.states = {};
__decorateClass([
  query("[data-backdrop]")
], UtilDrawer.prototype, "backdrop", 2);
__decorateClass([
  query("[data-drawer]")
], UtilDrawer.prototype, "drawer", 2);
__decorateClass([
  param("side")
], UtilDrawer.prototype, "side", 2);
__decorateClass([
  param("key")
], UtilDrawer.prototype, "key", 2);
__decorateClass([
  onClick("[data-backdrop]")
], UtilDrawer.prototype, "close", 1);
UtilDrawer = __decorateClass([
  defineElement("util-drawer")
], UtilDrawer);
export {
  UtilDrawer
};
